import cs from 'classnames';
import { usePlayerContext, VODProviderType } from 'hamrah-player';
import dynamic from 'next/dynamic';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { Box, Chip } from '@/DesignSystem/Component';
interface ITeacherDetailVideoProps {
  trailerUrl: string;
}
const Player = dynamic(() => import('hamrah-player').then(value => value.Player), {
  ssr: false
});
const VideoPlayerController: FC<{
  playHandler: () => void;
}> = ({
  playHandler
}) => {
  const {
    playerRef,
    initialed
  } = usePlayerContext();
  useEffect(() => {
    if (!playerRef.current || !initialed) return () => {};
    playerRef.current.on('play', playHandler);
    playerRef.current.on('pause', playHandler);
    return () => {
      playerRef.current.off('play', playHandler);
      playerRef.current.off('pause', playHandler);
    };
  }, [playerRef.current, initialed]);
  return null;
};
const TeacherDetailVideo: FC<ITeacherDetailVideoProps> = ({
  trailerUrl
}) => {
  const [isPlaying, setPlaying] = useState(false);
  const playHandler = () => {
    setPlaying(prevState => !prevState);
  };
  return <div className="customTeacher relative bg-blueFive bg-teacher-video p-6 md:px-8 md:py-20" data-sentry-component="TeacherDetailVideo" data-sentry-source-file="TeacherDetailVideo.tsx">
      <Box className={cs('relative top-0 mx-auto   before:absolute before:z-10 before:h-full before:bg-orangeSix before:opacity-[0.52] before:transition-all before:duration-200 before:content-[""] hover:before:h-0  hover:before:opacity-0  lg:max-w-[780px]', !isPlaying ? 'before:sm:w-full' : '')} color="orangeMiddle" data-sentry-element="Box" data-sentry-source-file="TeacherDetailVideo.tsx">
        <div className="mx-auto ">
          <Player playUrl={trailerUrl} vodType={VODProviderType.STANDARD} data-sentry-element="Player" data-sentry-source-file="TeacherDetailVideo.tsx">
            <VideoPlayerController playHandler={playHandler} data-sentry-element="VideoPlayerController" data-sentry-source-file="TeacherDetailVideo.tsx" />
          </Player>
        </div>
        {!isPlaying && <div className="pointer-events-none absolute bottom-8 z-20  px-2 sm:bottom-6 sm:px-8">
            <Chip title=" معرفی استاد" color="tertiary" radius="circle" className="mb-2 sm:mb-4" />
          </div>}
      </Box>
    </div>;
};
export default TeacherDetailVideo;